'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _sparkCore = require('@ciscospark/spark-core');

var _constants = require('../constants');

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class MeetingInfoRequest
 */
var PersonalMeetingRoomRequest = function (_StatelessSparkPlugin) {
  (0, _inherits3.default)(PersonalMeetingRoomRequest, _StatelessSparkPlugin);

  function PersonalMeetingRoomRequest() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PersonalMeetingRoomRequest);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PersonalMeetingRoomRequest.__proto__ || (0, _getPrototypeOf2.default)(PersonalMeetingRoomRequest)).call.apply(_ref, [this].concat(args))), _this), _this.namespace = _constants.MEETINGS, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PersonalMeetingRoomRequest, [{
    key: 'claimPmr',


    /**
     *
     * @param {Object} options with format of {userId, passcode, meetingAddress, preferred}
     * @returns {Promise} returns a promise that resolves/rejects the result of the request
     * @memberof PersonalMeetingRoomRequest
     */
    value: function claimPmr(options) {
      if (!options || !options.userId || !options.passcode || !options.meetingAddress || !options.preferred) {
        throw new Error('Claiming a PMR should be done with userId, passcode, preferred, and meetingAddress in options.');
      }
      var validPin = _util2.default.getClaimPmrPin(options.passcode);
      if (!validPin) {
        return _promise2.default.reject(new Error('The host pin provided was of an invalid format'));
      }
      var validLink = _util2.default.getClaimPmrLink(options.meetingAddress);
      if (!validLink) {
        return _promise2.default.reject(new Error('The PMR link provided was of an invalid format'));
      }
      var request = _util2.default.getClaimedRequestParams(validLink, validPin, options);
      return this.request(request);
    }
  }]);
  return PersonalMeetingRoomRequest;
}(_sparkCore.StatelessSparkPlugin);

exports.default = PersonalMeetingRoomRequest;
//# sourceMappingURL=request.js.map
